<div class="go-action-sheet">
  <div class="go-action-sheet__button" (click)="triggerAS()">
    <ng-content select="[go-action-sheet__button]"></ng-content>
  </div>
    
  <div class="go-action-sheet__content-container"
       [ngClass]="containerClass()"
       aria-expanded="true">
    <div class="go-action-sheet__content">
      <div class="go-action-sheet__scroll-container">
        <ng-content select="[go-action-sheet-content]"></ng-content>
      </div>
    </div>
  </div>
</div>
